<div class={{cssClass}}>
    {{ label | translate}}
</div>
